<template>
    <div
        v-if="appEnvironmentTag"
        class="dark:text-white dark:bg-red-950 bg-red-100 text-center mx-3 my-3 border rounded-lg dark:border-red-800 border-red-600 p-2"
    >
        <span class="mr-2">{{ envIcon }}</span>
        <span
            class="inline-flex items-center mr-2 px-1 py-0.5 rounded text-xs font-medium bg-red-600 text-red-200 dark:bg-red-800 dark:text-red-200"
            :title="appBuildNumber"
        >
            {{ appEnvironmentTag }} #{{ buildNum }}
        </span>
        v{{ appVersion }}
    </div>
</template>
<script>
export default {
    name: "cStagingMarker",
    computed: {
        envIcon() {
            return (
                {
                    dev: "🚧",
                    demo: "🎭",
                    stage: "🚀",
                    e2e: "⚙",
                }[this.appEnvironmentTag] || "🛑"
            );
        },
        appVersion() {
            return process.env.VUE_APP_VERSION;
        },
        appEnvironmentTag() {
            return process.env.VUE_APP_STAGING_ENV;
        },
        buildNum() {
            return process.env.VUE_APP_BUILD_NO;
        },
        appBuildNumber() {
            return "Build #no: " + this.buildNum;
        },
    },
};
</script>
